import React from "react"

import { UserLocationButton } from "./UserLocationButton"
import { openLocationPopup } from "../utils/lazyPopups"

interface UserLocationProps {
  style?: React.CSSProperties
  textPosition?: string
  iconColor?: string
  iconStyle?: React.CSSProperties
  hideIcon?: boolean
  viewOnly?: boolean
  color?: any
  fullWidth?: boolean
  textButton?: boolean
  onClick?: () => void
}

export const UserLocation: React.FC<UserLocationProps> = function (props: any) {
  const { viewOnly, textButton, color, style, onClick } = props

  const openSelector = React.useCallback(() => {
    void openLocationPopup()
  }, [])

  if (viewOnly)
    return (
      <UserLocationButton
        hideIcon
        style={style}
        color={color}
        textButton={textButton}
        onPress={onClick || openSelector}
      />
    )

  return <UserLocationButton textButton={textButton} onPress={openSelector} />
}
